// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__5sbxb","productName":"Table_productName__7EyWs"};